(function ($, njm) {
    'use strict';

    njm.views.customModal = Backbone.View.extend({
		
		events: {
			"click .close": "closeModal",
			"focus .form-group input, .form-group textarea": "handleFieldFocus",
			"blur .form-group input, .form-group textarea": "handleFieldBlur"
		},
		
		initialize: function() {
			
			if (!window.customModal) {
				window.customModal = {};
			}
			
			if (!window.customModal.initialized) {
				window.customModal.initialized = true;
				
				$('body').click(this.handleBodyClicks.bind(this));
				$('body').keydown(this.handleKey.bind(this));
				$('body').on('click', 'a', this.handleLinkClicks.bind(this));
				
				//check for modal the in url
				this.hash = window.location.hash;
				if (this.hash.indexOf('modal') > -1) {
					var exists = this.openGenericCustomModal(this.hash);

					if (!exists) {
						this.hash = null;
					}
				}
			}
			
			// Get all the modals on the page
			this.modal = $('.custom-modal');
			
			// Array of all focusable elements
			this.focusableEls;
			this.lastElement;
			this.firstElement;
			
			//variable to capture the potential presence of a scrollbar
			this.scroll;
			
		},
		
		handleBodyClicks: function(event) {
			
			if (this.modal.hasClass('visible') && $(event.target).closest('.custom-modal .modal-content').length === 0) {
				this.closeModal();
			}
			
		},
		
		handleLinkClicks: function(event) {
			
			var hrefVal = $(event.target).closest('a').attr("href");

			if (hrefVal != '' && hrefVal != undefined && hrefVal != null) {
				if (hrefVal === "#modal") {
					this.openGenericModal();
					return false;
				}
				else if (hrefVal.indexOf("#modal") == 0) {
					this.openGenericCustomModal(hrefVal);
					return false;
				}
			}
			else {
				return true;
			}
			
		},
		
		handleKey: function() {
			
			if (this.modal.hasClass('visible') && event.which === 27) {
				this.closeModal();
			}
			
			if (event.which === 9) {
				this.handleTab(event);
			}
			
			if ($(event.target).closest('.custom-modal .close').length === 1 && event.which === 13 ) {
				this.closeModal();
			}
		},
		
		handleTab: function(event) {
			
			if (event.currentTarget == this.firstElement) {
				if (this.focusableEls.length === 1 && event.which === 9) {
					event.preventDefault();
				} else if(this.focusableEls.length > 1 && event.which === 9) {
					if (event.shiftKey) {
						this.lastElement.focus();
						event.preventDefault();
					}
				}
			}
			
			if (event.currentTarget == this.lastElement) {
				if (this.focusableEls.length === 1 && event.which === 9) {
					event.preventDefault();
				} else if(this.focusableEls.length > 1 && event.which === 9) {
					if (event.shiftKey) {
						return true;
					} else {
						this.firstElement.focus();
						event.preventDefault();
					}
				}
			}
		},
		
		handleFieldFocus: function(event) {
			$(event.target).parents('.form-group').addClass('focused');
		},
		
		handleFieldBlur: function(event) {
			
			var $target = $(event.target),
				inputValue = $target.val();
			
			if (inputValue ==+ "") {
				$target.parents('.form-group').removeClass('focused');
				$target.removeClass('filled');
			} else {
				$target.addClass('filled');
			}
		},
		
		openGenericModal: function() {
			
			var formModal = $('#generic-custom-modal');
		
			if (formModal.length) {
				this.scroll = ($(document).height() > window.innerHeight);
				
				if (this.scroll) {
					$('body').css('padding-right', this.measureScrollbarWidth() + 'px');
				}
				
				if (!window.customModal) {
					window.customModal = {};
				}
				window.customModal.activeEl = $(document.activeElement);
				
				formModal.fadeIn(100).addClass('visible');
				$('body').addClass('modal-open');
				
				this.setFocusableEls(formModal)
				
				formModal.find('.close').focus();
			}
		},
		
		openGenericCustomModal: function(modalid) {

			
			var customModal = $(modalid);
		
			if (customModal.length) {
				
				this.scroll = ($(document).height() > window.innerHeight);

				if (this.scroll) {
					$('body').css('padding-right', this.measureScrollbarWidth() + 'px');
				}
				
				if (!window.customModal) {
					window.customModal = {};
				}
				window.customModal.activeEl = $(document.activeElement);
				
				customModal.fadeIn(100).addClass('visible');
				$('body').addClass('modal-open');
				
				this.setFocusableEls(customModal)
				
				customModal.find('.close').focus();
				
				return true;
			} else {
				return false;
			}
		},
		
		setFocusableEls: function(modal) {
			
			this.focusableEls = modal.find('a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
			if (this.focusableEls.length) {
				this.lastElement = this.focusableEls[this.focusableEls.length - 1];
				this.firstElement = this.focusableEls[0];
				$(this.firstElement).keydown(this.handleTab.bind(this));
				$(this.lastElement).keydown(this.handleTab.bind(this));
			}
		},
		
		closeModal: function() {
			this.modal.hide();
			
			$('body').removeClass('modal-open');
			
			if (this.scroll) {
				$('body').css('padding-right','');
			}
			
			this.modal.removeClass('visible');
			
			if (window.customModal && window.customModal.activeEl) {
				window.customModal.activeEl.focus();
			}
			
			this.focusableEls = [];
			this.lastElement = null;
			this.firstElement = null;
		},
		
		measureScrollbarWidth: function() {
			return window.innerWidth - $(document).width();
		}
		
	});
})(jQuery, njm);
